<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VFRl4x/tc-custom/9781250089458.jpg?1738254592690" alt="This image is the cover for the book A Million Years in a Day"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Million Years in a Day
      </h1>
      <p class="bookDescription body article font2">
        <p>Who invented beds? When did we start cleaning our teeth? How old are wine and beer? Which came first: the toilet seat or toilet paper? What was the first clock?<br/><br/>Every day, from the moment our alarm clock wakes us in the morning until our head hits our pillow at night, we all take part in rituals that are millennia old. Structured around one ordinary day, <i>A Million Years in a Day </i>reveals the astonishing origins and development of the daily practices we take for granted. In this gloriously entertaining romp through human history, Greg Jenner explores the gradual—and often unexpected—evolution of our daily routines.<br/><br/>This is not a story of wars, politics, or great events. Instead, Jenner has scoured Roman rubbish bins, Egyptian tombs, and Victorian sewers to bring us the most intriguing, surprising, and sometimes downright silly historical nuggets from our past.<br/><br/>Drawn from across the world, spanning a million years of humanity, this book is a smorgasbord of historical delights. It is a history of all those things you always wondered about—and many you have never considered. It is the story of your life, one million years in the making.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Jenner
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b2ad95e